import { ref } from 'vue';
import dayjs from 'dayjs';
import qs from 'qs';
import { ElMessage, ElMessageBox, ElLoading } from 'element-plus';
import { useClipboard } from '@vueuse/core';
import relativeTime from 'dayjs/plugin/relativeTime';
import request from './request';
import apiPath from '@/lib/apiPath';
import { needLogin } from '@/lib/request';
import { TokenKey } from '@/lib/token';

dayjs.extend(relativeTime);

let loadingInstance = null;

export const BACKEND_ID = '157302467900000021'; // 灵盾后台id

export function formatTime(timestamp, locale = 'YYYY-MM-DD HH:mm:ss') {
  return dayjs.unix(Number(timestamp)).format(locale);
}

export function formatSecond(value) {
  if (!value) {
    return '0秒';
  }
  let second = Number(value);
  let minute = 0;
  let hour = 0;
  if (second > 60) {
    minute = Math.floor(second / 60);
    second = Math.floor(second % 60);
    if (minute > 60) {
      hour = Math.floor(minute / 60);
      minute = Math.floor(minute % 60);
    }
  }
  let result = second + '秒';
  if (minute > 0) {
    result = minute + '分' + result;
  }
  if (hour > 0) {
    result = hour + '时' + result;
  }
  return result;
}

export function formatMoney(value) {
  if (value) {
    return Number(value).toLocaleString('zh-CN', {
      style: 'currency',
      currency: 'CNY',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
  return '￥0';
}

export function scrollToBottomById(id) {
  const ele = document.getElementById(id);
  if (ele) {
    ele.scrollTop = ele.scrollHeight;
  }
}
export function copyText(text, showMsg = true) {
  try {
    const source = ref(text);
    const { copy } = useClipboard({ source });
    copy();
    if (showMsg) {
      ElMessage({
        type: 'success',
        message: '复制成功',
      });
    }
  } catch (error) {
    console.log(error);
  }
}

export function setLoading(options = {}) {
  loadingInstance = ElLoading.service(
    Object.assign({ lock: true, text: '加载中，请耐心等候...', target: '#main-container' }, options)
  );
}

export function deDuplication(arr, property) {
  let tmp = {};
  let result = [];
  arr.forEach((i) => {
    if (!tmp[i[property]]) {
      tmp[i[property]] = true;
      result.push(i);
    }
  });
  return result;
}

export function cancelLoading() {
  loadingInstance && typeof loadingInstance.close === 'function' && loadingInstance.close();
}

export function getQueryFromUrl(key, url = '') {
  let queryString = qs.parse(url ? url : location.search, {
    ignoreQueryPrefix: true,
  });
  if (key instanceof Array) {
    let obj = {};
    for (let i of key) {
      obj[i] = queryString[i];
    }
    return obj;
  }
  return queryString[key] || '';
}

export function delQuery(url) {
  return url.split('?')[0];
}

export function getExt(fileName) {
  return fileName.replace(/.+\./, '').toLowerCase();
}

export function isPicture(fileName) {
  const ext = getExt(fileName);
  return ['png', 'jpg', 'jpeg', 'bmp'].includes(ext);
}

export function getFileType(fileName) {
  const ext = getExt(fileName);
  if (['png', 'jpg', 'jpeg', 'bmp'].includes(ext)) {
    return 'image';
  } else if (['mp4', 'avi', 'mkv'].includes(ext)) {
    return 'video';
  } else {
    return 'other';
  }
}

export const confirmFn = ({
  title = '提示',
  message = '',
  confirmButtonText = '确定',
  cancelButtonText = '取消',
  onOk = () => {},
  onCancel = () => {},
}) => {
  ElMessageBox.confirm(message, title, {
    confirmButtonText,
    cancelButtonText,
  })
    .then(() => {
      typeof onOk === 'function' && onOk();
    })
    .catch(() => {
      typeof onCancel === 'function' && onCancel();
    });
};

export function getVideoPlayerInfo(file) {
  return new Promise((resolve) => {
    const videoElement = document.createElement('video');
    videoElement.src = URL.createObjectURL(file);
    videoElement.play();
    videoElement.addEventListener('loadedmetadata', function () {
      resolve({
        duration: videoElement.duration,
        width: videoElement.videoWidth,
        height: videoElement.videoHeight,
      });
    });
  });
}

export function validateData(type, val) {
  let RegExps = {
    phone: /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-79])|(?:5[0-35-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[189]))\d{8}$/,
    email:
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  };
  if (type && val) {
    return RegExps[type].test(val);
  }
  return false;
}

export function downLoadImage(imgSrc, name = '新建图片') {
  let fileName = /\.(png|PNG)$/.test(name) ? name : name + '.png';
  const img = new Image();
  img.setAttribute('crossOrigin', 'anonymous');
  img.onload = () => {
    let canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    let ctx = canvas.getContext('2d');
    ctx?.drawImage(img, 0, 0, img.width, img.height);
    let url = canvas.toDataURL('image/png');
    let a = document.createElement('a');
    a.download = fileName;
    a.href = url;
    a.click();
  };
  img.src = imgSrc;
}

export async function downloadFile(type = 'quick_reply', filename = '导出文件') {
  const { token } = await request.get(apiPath.download.getDownLoadToken.replace(':type', type));
  let res = await request.get(
    apiPath.download.downloadByType.replace(':type', type),
    {
      token,
    },
    {
      responseType: 'blob',
    }
  );
  const blob = new Blob([res]);
  const href = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = href;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
}

export function showMicrometersNumber(val) {
  return val ? Number(val).toLocaleString() : val;
}

export function validatePageParams(val, field = 'from') {
  return getQueryFromUrl(field) === val;
}

export const loadJs = (src) => {
  return new Promise((resolve, reject) => {
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    document.body.appendChild(script);

    script.onload = () => {
      resolve();
    };
    script.onerror = () => {
      reject();
    };
  });
};

export const randomString = (e) => {
  e = e || 32;
  var t = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
    a = t.length,
    n = '';
  for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a));
  return n;
};

export const formatEnv = (v) => {
  const env = envMap.find((e) => e.value === v);
  return env ? env.label : '未知系统';
};

// 是否有交集
export const hasIntersection = (arr1, arr2) => {
  return arr1.some((item) => arr2.includes(item));
};

export const envMap = [
  {
    label: '正式环境',
    value: 'production',
  },
  {
    label: '测试环境',
    value: 'sandbox',
  },
  {
    label: '本地环境',
    value: 'development',
  },
  {
    label: '其他应用',
    value: 'external',
  },
];

export const presidents = ['元素', '敦敏', '文和', '文德', '云长', '天成', '晨曦', '子牙', '静远'];
export const directors = ['子龙', '仲达', '思明', '小汐', '原子', '铂锡', '昆吾', '德操', '铭汐', '柏霖'];

// 获取指定后台的token
export const getBackendToken = (backend_id) => {
  return request.get(apiPath.base.getToken, {
    backend_id,
  });
};

// 服务中心后台token
export const handlerServiceCenterBackendToken = (limitOpt) => {
  const backend_ids = {
    serviceCenterAdminSingapore: '174124388956310240',
    serviceCenterAdminSingapore_Dev: '174124388956310250',
    serviceCenterAdmin: '174124388956310240',
    serviceCenterAdmin_Dev: '174124388956310250',
  };
  const isDev = limitOpt?.endsWith('_Dev');
  const backend_id = backend_ids[limitOpt]
    ? backend_ids[limitOpt]
    : backend_ids[isDev ? 'serviceCenterAdmin_Dev' : 'serviceCenterAdmin'];
  return getBackendToken(backend_id);
};

// 登录回调地址
export const handlerRedirectUrlByLimitOpt = async ({ limitOpt, userInfo }) => {
  const BACKEND_LIMIT_URL_MAP = {
    crm: 'https://ai-tools.seeronnet.com',
    crmDev: 'https://sandbox-ai-tools.seeronnet.com',
    serviceCenterTools: 'https://dc.gzyt123.cn',
    serviceCenterToolsDev: 'https://sandbox-dc.jinhuihh.com',
    serviceCenterAdmin: 'https://sc.seeronnet.com',
    serviceCenterAdminDev: 'https://sandbox-sc.seeronnet.com',
    serviceCenterAdminSingapore: 'https://sc.seeronnet.com',
    serviceCenterAdminSingaporeDev: 'https://sandbox-sc.seeronnet.com',
  };
  if (['crm', 'crm_Dev'].includes(limitOpt)) {
    // 录单插件，limitOpt以后缀为_Dev区分测服
    const url = limitOpt?.endsWith('_Dev') ? BACKEND_LIMIT_URL_MAP['crmDev'] : BACKEND_LIMIT_URL_MAP['crm'];
    location.href = `${url}/collectOrder?collectInfo=${JSON.stringify(userInfo)}`;
  } else if (limitOpt.startsWith('crmPayment')) {
    // 收款插件，limitOpt以后缀为_Dev区分测服
    const url = limitOpt?.endsWith('_Dev') ? BACKEND_LIMIT_URL_MAP['crmDev'] : BACKEND_LIMIT_URL_MAP['crm'];
    location.href = `${url}/paymentCollection?collectInfo=${JSON.stringify(userInfo)}`;
  } else if (limitOpt.startsWith('recommend')) {
    // 推荐员工插件，limitOpt以后缀为_Dev区分测服
    const url = limitOpt?.endsWith('_Dev') ? BACKEND_LIMIT_URL_MAP['crmDev'] : BACKEND_LIMIT_URL_MAP['crm'];
    location.href = `${url}/recommendEmployee?collectInfo=${JSON.stringify(userInfo)}`;
  } else if (limitOpt.startsWith('serviceCenterAdmin')) {
    // 服务中心后台，limitOpt以后缀为_Dev区分测服
    const isDev = limitOpt?.endsWith('_Dev');
    const { token } = await handlerServiceCenterBackendToken(limitOpt);
    const url =
      limitOpt.indexOf('Singapore') !== -1
        ? BACKEND_LIMIT_URL_MAP[isDev ? 'serviceCenterAdminSingaporeDev' : 'serviceCenterAdminSingapore']
        : BACKEND_LIMIT_URL_MAP[isDev ? 'serviceCenterAdminDev' : 'serviceCenterAdmin'];
    location.href = `${url}/?access_token=${token}`;
  } else if (limitOpt.startsWith('serviceCenterTools')) {
    // 服务中心企微工具栏每次跳转都要求重新登录（判断Token是否一分钟内创建）
    const tokenCreateTime = JSON.parse(window.localStorage?.getItem(TokenKey) || '{}')?.create;
    if (new Date().getTime() - tokenCreateTime > 60 * 1000) {
      needLogin();
    } else {
      const isDev = limitOpt?.endsWith('_Dev');
      const { token } = await handlerServiceCenterBackendToken(limitOpt);
      // limitOpt为路由的拼接字符 xxx_yyy -> /xxx/yyy，测服环境limitOpt后缀带_Dev：【xxx_yyy_Dev】
      isDev && (limitOpt = limitOpt?.slice(0, limitOpt.length - 4));
      const routePath = limitOpt?.split('_')?.join('/');
      location.href = `${
        BACKEND_LIMIT_URL_MAP[isDev ? 'serviceCenterToolsDev' : 'serviceCenterTools']
      }/${routePath}?access_token=${token}`;
    }
  }
};
